import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@chakra-ui+react@3.37.0_@emotion+react@11.14.0_@types+react@19.0.2_react@18.3.1__react-_e7aa4d446145c777e58dffee992da571/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/app/node_modules/.pnpm/@chakra-ui+react@3.37.0_@emotion+react@11.14.0_@types+react@19.0.2_react@18.3.1__react-_e7aa4d446145c777e58dffee992da571/node_modules/@chakra-ui/react/dist/esm/components/container/container.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/node_modules/.pnpm/@chakra-ui+react@3.37.0_@emotion+react@11.14.0_@types+react@19.0.2_react@18.3.1__react-_e7aa4d446145c777e58dffee992da571/node_modules/@chakra-ui/react/dist/esm/components/separator/separator.js");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/app/node_modules/.pnpm/@chakra-ui+react@3.37.0_@emotion+react@11.14.0_@types+react@19.0.2_react@18.3.1__react-_e7aa4d446145c777e58dffee992da571/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/_styles/embla.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/AlertWorkingHours/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(home)/_components/Carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/CashbackQR/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/HomeContent/HomeOrderTypeSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/HomeContent/MobileCartBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/HomeContent/PopupsLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/HomeContent/ShipperRenderGuard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(home)/_components/Menu/Landing/_components/Carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/Menu/Landing/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/Products/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/Stories/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/_components/UpBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/loading.tsx");
